import * as Yup from 'yup';
import { parseISO } from 'date-fns';
import { getTodayStr } from '@ourbranch/date-fns-helpers';

// #33939 — a manual Loss History entry requires only Cause of Loss and Loss Date; every other
// field is optional (matching the auto-pulled entries' required fields).
export const addLossHistoryValidationSchema = Yup.object().shape({
  causeOfLoss: Yup.string().trim().required('Cause of loss is required'),
  lossDate: Yup.date()
    .required('Loss date is required')
    // Business "today" (state-aware, America/New_York) is computed at validation time, NOT bound at
    // module load — so a long-lived tab open past midnight ET doesn't drift. AGENTS.md: never use a
    // raw `new Date()` for a business date (off-by-a-day near midnight ET).
    .test('not-future', 'Loss date cannot be in the future', (value) => !value || value <= parseISO(getTodayStr()))
});
